import { render } from "./TableWriteOffRates.vue?vue&type=template&id=f9ca64b6&scoped=true"
import script from "./TableWriteOffRates.vue?vue&type=script&lang=js"
export * from "./TableWriteOffRates.vue?vue&type=script&lang=js"

import "./TableWriteOffRates.vue?vue&type=style&index=0&id=f9ca64b6&lang=scss&scoped=true"

import exportComponent from "/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9ca64b6"]])

export default __exports__